import axios from "axios";
import { Token } from "../utils/localStorage.util";
import config from "../config.js";

const apiImportacoes = axios.create({
  baseURL: config.REACT_APP_HOST_API_IMPORTACOES,
});

apiImportacoes.interceptors.request.use(
  async (config) => {
    const token = Token.getToken();
    if (token) {
      config.headers.Authorization = token;
    }

    if (!config.headers["Content-Type"]) {
      config.headers["Content-Type"] = "application/json";
    }

    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

apiImportacoes.interceptors.response.use(
  (response) => {
    return response.data;
  },

  async function (error) {
    if (error?.code === "ERR_NETWORK") {
      console.error("Erro de conexão (ERR_NETWORK):", error);
      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

export function buscarProcessos(dataFiltro = null, filtros = {}, page = 1, limit = 10) {
  const params = new URLSearchParams();
  
  // Aplicar dataFiltro apenas se não houver outros filtros
  const temFiltros = filtros.tipo || filtros.status || filtros.cnpj;
  if (dataFiltro && !temFiltros) {
    params.append('dataFiltro', dataFiltro);
  }
  
  // Adicionar filtros se existirem
  if (filtros.tipo) {
    params.append('tipo', filtros.tipo);
  }
  if (filtros.status) {
    params.append('status', filtros.status);
  }
  if (filtros.cnpj) {
    params.append('cnpj', filtros.cnpj);
  }
  
  // Adicionar paginação
  params.append('page', page.toString());
  params.append('limit', limit.toString());
  
  const queryString = params.toString();
  const url = `/sped/buscar-todos-processos${queryString ? '?' + queryString : ''}`;
  console.log('[api-importacoes.service] buscarProcessos - URL:', url);
  return apiImportacoes.get(url).then(response => {
    console.log('[api-importacoes.service] buscarProcessos - Resposta completa:', response);
    return response;
  });
}

export function buscarProcessosPorTexto(texto, page = 1, limit = 10) {
  const params = new URLSearchParams();
  params.append('texto', texto);
  params.append('page', page.toString());
  params.append('limit', limit.toString());
  return apiImportacoes.get(`/sped/buscar-processos-por-texto?${params.toString()}`);
}

export function inserirImportacaoSped(body) {
  return apiImportacoes.post(`/importador/inserir-fila-sped`, body);
}

export default apiImportacoes;
